module.exports = __webpack_public_path__ + "static/media/feature3.09e454de.png";